import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import {
  MANUAL_ID_VERIFICATION_STATUS_APPROVED,
  MANUAL_ID_VERIFICATION_STATUS_REJECTED,
  MANUAL_ID_VERIFICATION_STATUS_RETRY,
} from 'common/manualIdVerificationConstants';

import { SR_API_ACTION_MANUAL_ID_VERIFICATION_REVIEW } from 'api/actionTypes';

import { SCREEN_ID_ADMIN_MANUAL_ID_VERIFICATION } from 'client/constants/screenIds';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';

import postWithState from 'client/actions/postWithState';
import ManualIdVerificationActions from 'client/actions/ManualIdVerification';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrText from 'client/components/SrText';
import SrReviewManualIdVerification from 'client/components/SrReviewManualIdVerification';

const MANUAL_ID_VERIFICATION_STATUS_TO_ACTION = {
  [MANUAL_ID_VERIFICATION_STATUS_APPROVED]: 'approve',
  [MANUAL_ID_VERIFICATION_STATUS_REJECTED]: 'reject',
  [MANUAL_ID_VERIFICATION_STATUS_RETRY]: 'retry',
};

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_MANUAL_ID_VERIFICATION)
@withScrollToTop
@branch({
  manualIdVerificationsList: ['manualIdVerifications', 'list'],
})
class AdminManualIdVerificationPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Manual ID Verifications | Sunroom Rentals',
  });

  static propTypes = {
    manualIdVerificationsList: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this._manualIdVerificationLongPollingInterval = null;
  }

  componentDidMount() {
    this._manualIdVerificationLongPollingInterval = setInterval(
      () => this._loadManualIdverifications(),
      2000,
    );
  }

  componentWillUnmount() {
    clearInterval(this._manualIdVerificationLongPollingInterval);
  }

  _loadManualIdverifications = () => {
    const { dispatch } = this.props;
    dispatch(ManualIdVerificationActions.getPendingList);
  };

  _onReviewManualIdVerification = ({ status, manualIdVerificationId }) => {
    const { dispatch } = this.props;
    const action = MANUAL_ID_VERIFICATION_STATUS_TO_ACTION[status];

    if (!global.confirm(`Are you sure you want to ${action}?`)) {
      return;
    }
    dispatch(postWithState, {
      action: SR_API_ACTION_MANUAL_ID_VERIFICATION_REVIEW,
      payload: {
        manualIdVerificationId,
        status,
      },
    }).then(this._loadManualIdverifications);
  };

  render() {
    const { manualIdVerificationsList } = this.props;

    return (
      <SrPartnerPageV2 backUrl="/admin" navbarTitle="Identity Review" pageHeader="Identity Review">
        <SrText font="greycliff" size="32" weight="800">
          Tours
        </SrText>
        {manualIdVerificationsList.map((manualIdVerification) => (
          <SrReviewManualIdVerification
            key={manualIdVerification.id}
            manualIdVerification={manualIdVerification}
            reviewManualIdVerification={this._onReviewManualIdVerification}
          />
        ))}
      </SrPartnerPageV2>
    );
  }
}

AdminManualIdVerificationPage.displayName = 'AdminManualIdVerificationPage';

export default AdminManualIdVerificationPage;
